import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import { findPreorder, updatePreorder } from '../service/OrdersService';
import Message from '../components/LoadingError/Error';
import { useEffect } from 'react';
import Loading from '../components/LoadingError/Loading';

const PaymentScreen = ({ user }) => {
  const [deliveryMethod, setDeliveryMethod] = useState({
    domicilio: false,
    tienda: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const navigate = useNavigate();
  const params = useParams();
  const preorderId = params.id;

  useEffect(() => {
    if (user) {
      findPreorder(preorderId).then((preorder) => {
        if (!preorder[0].userAddress) {
          navigate(`/user-address/${preorderId}`);
        }
        if (preorder[0].deliveryMethod) {
          if (preorder[0].deliveryMethod === 'domicilio') {
            setDeliveryMethod({
              domicilio: true,
              tienda: false,
            });
          }
          if (preorder[0].deliveryMethod === 'tienda') {
            setDeliveryMethod({
              domicilio: false,
              tienda: true,
            });
          }
        }
        setLoading(false);
      });
    }
  }, [user]);

  const handlePaymentMethod = (method) => {
    if (method === 'domicilio') {
      if (deliveryMethod.domicilio) {
        setDeliveryMethod({
          domicilio: false,
          tienda: false,
        });
      } else {
        setDeliveryMethod({
          domicilio: true,
          tienda: false,
        });
      }
    }
    if (method === 'tienda') {
      if (deliveryMethod.tienda) {
        setDeliveryMethod({
          domicilio: false,
          tienda: false,
        });
      } else {
        setDeliveryMethod({
          domicilio: false,
          tienda: true,
        });
      }
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    updatePreorder(
      {
        deliveryMethod: Object.keys(deliveryMethod).filter(
          (method) => deliveryMethod[method]
        )[0],
      },
      preorderId
    )
      .then(() => {
        if (deliveryMethod.domicilio) {
          navigate(`/shipping/${preorderId}`);
        }
        if (deliveryMethod.tienda) {
          navigate(`/payment/${preorderId}`);
        }
      })
      .catch((error) => setError(error.response.data.message));
  };

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex justify-content-center align-items-center mt-md-5'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <form
            className='Login2 col-md-8 col-lg-6 col-11'
            onSubmit={submitHandler}
          >
            <h6>SELECCIONAR MODO DE ENTREGA</h6>
            <div className='payment-container mt-5'>
              <div className='radio-container my-3 d-flex align-items-start'>
                <input
                  className='form-check-input'
                  type='radio'
                  value='domicilio'
                  checked={deliveryMethod.domicilio}
                  onClick={(e) => handlePaymentMethod(e.target.value)}
                />
                <div className='d-flex flex-column '>
                  <label className='form-check-label'>Envío a domicilio</label>
                  <small className='ms-3'>
                    * + 5,95 € (Gratis en pedidos superiores a 200 €)
                  </small>
                </div>
              </div>
              <div className='radio-container my-3 d-flex align-items-start'>
                <input
                  className='form-check-input'
                  type='radio'
                  value='tienda'
                  checked={deliveryMethod.tienda}
                  onClick={(e) => handlePaymentMethod(e.target.value)}
                />
                <div className='d-flex flex-column '>
                  <label className='form-check-label'>Recogida en tienda</label>
                  <small className='ms-3'>* + 0 €</small>
                  <small className='ms-3'>* Se permite pago en mano</small>
                </div>
              </div>
            </div>

            <button
              disabled={!deliveryMethod.domicilio && !deliveryMethod.tienda}
              style={{
                backgroundColor:
                  !deliveryMethod.domicilio && !deliveryMethod.tienda && 'grey',
              }}
              type='submit'
            >
              Continuar
            </button>
          </form>
        )}
      </div>
    </>
  );
};

export default PaymentScreen;
